import { z } from "zod"
import { CustomerImportFieldEnum, CustomerImportTargetEnum } from "./commonTypes"

export const ImportCustomersSchemaFile = z.object({
  file: z.object({
    data: z.unknown().refine((value) => Buffer.isBuffer(value), {
      error: "Expected a Buffer",
    }),
    name: z.string(),
  }),
})

export const ImportCustomersSchema = z.object({
  preview: z
    .union([z.literal("true"), z.literal("false"), z.boolean()])
    .transform((val) => (typeof val === "string" ? val === "true" : val)),
  campaignId: z.string().transform(BigInt).optional(),
  // Multipart bodies only carry strings, so the column mapping travels as JSON
  columns: z
    .string()
    .transform((value, ctx) => {
      try {
        return JSON.parse(value) as unknown
      } catch {
        ctx.addIssue({ code: "custom", message: "Invalid columns" })
        return z.NEVER
      }
    })
    .pipe(
      z.array(CustomerImportTargetEnum).refine((targets) => {
        const fields = targets.filter((target) => CustomerImportFieldEnum.safeParse(target).success)
        return new Set(fields).size === fields.length
      }, "Each field can only be matched to one column"),
    )
    .optional(),
  defaultCountry: z.string().length(2).optional(),
  skipInvalidRows: z
    .union([z.literal("true"), z.literal("false"), z.boolean()])
    .transform((val) => (typeof val === "string" ? val === "true" : val))
    .optional(),
})
